import {api} from '../../../system/api';

export default {
    changePackageTransportStatus: (params) => api.put("packages/" + params.code + "/change-transport-status", {status_transport: params.status_transport}),
    updateTransportStatus: data => api.put(`/packages/${data.code}/update-transport-status`, {
        status_transport: data.status_transport
    })
};
